import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getStitchingtaskList } from 'components/stitchingtask/StitchingtaskAPI';
import { setStitchingtaskList, setStitchingtaskDashboardStitchingtaskList } from 'store/slice/ManufSlice';
import StitchingtaskDashboard from '../StitchingtaskDashboard';

export default function StitchingtaskPageImpl() {
    const dispatch = useDispatch();
    const { stitchingtaskList} = useSelector((state)=>state.manufslice);
    
    const getStitchingtaskListSuccess = (list) =>{dispatch(setStitchingtaskList(list));}
    useEffect(() => {
        getStitchingtaskList(()=>{}, getStitchingtaskListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setStitchingtaskDashboardStitchingtaskList( stitchingtaskList));
    },[ stitchingtaskList])

    return (
        < StitchingtaskDashboard />
    )

}